import * as Sentry from "@sentry/react";
import React from "react";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router-dom";

if ((import.meta.env.VITE_SENTRY_IS_ENABLED ?? "").toLowerCase() === "true") {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [
			Sentry.replayIntegration(
				import.meta.env.VITE_VERSION?.toLowerCase?.() !== "production"
					? {
							maskAllText: false,
							blockAllMedia: false,
						}
					: undefined,
			),
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect: React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
		],
		tracesSampleRate: 1.0,
		// tracePropagationTargets: [new RegExp(`${import.meta.env.VITE_API_URL}/*`)],
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		environment: import.meta.env.VITE_VERSION,
	});
}

export const logWarning = (
	message: string,
	extras: Record<string, unknown> = {},
) => {
	Sentry.captureMessage(message, (scope) => {
		scope.setLevel("warning");
		for (const [key, value] of Object.entries(extras)) {
			scope.setExtra(key, value);
		}
		return scope;
	});
};
